/**
 * Vertical Menu Highlight System
 * Script pentru evidențierea categoriilor din meniul vertical cu culori personalizate
 * 
 * Utilizare:
 * 1. Apelează funcția highlightMenuItem() pentru a evidenția un element
 * 2. Configurează culorile și efectele dorite
 */

(function() {
  'use strict';

  // Configurare globală
  const VerticalMenuHighlight = {
    
    /**
     * Aplică highlight pe un element din meniul vertical
     * @param {Object} options - Opțiuni de configurare
     * @param {string} options.itemTitle - Titlul exact al elementului din meniu (ex: "Laptopuri", "Telefoane")
     * @param {string} options.backgroundColor - Culoarea de fundal (ex: '#ff6b6b', 'rgba(255, 107, 107, 0.1)')
     * @param {string} options.textColor - Culoarea textului (ex: '#ffffff', '#333333')
     * @param {string} options.borderColor - Culoarea bordurii (opțional)
     * @param {boolean} options.pulse - Efect de pulsare (true/false)
     * @param {boolean} options.glow - Efect de strălucire (true/false)
     * @param {string} options.badge - Text pentru badge (ex: "HOT", "NEW", "SALE")
     * @param {string} options.badgeColor - Culoarea badge-ului
     */
    highlightMenuItem: function(options) {
      const defaults = {
        itemTitle: '',
        backgroundColor: '#ff6b6b',
        textColor: '#ffffff',
        borderColor: '',
        pulse: false,
        glow: false,
        badge: '',
        badgeColor: '#e74c3c',
        fontWeight: 'bold',
        fontSize: '',
        icon: '' // Font Awesome icon class (ex: 'fa-star', 'fa-fire')
      };

      const settings = Object.assign({}, defaults, options);

      if (!settings.itemTitle) {
        console.warn('VerticalMenuHighlight: itemTitle este obligatoriu');
        return;
      }

      // Găsește elementul din meniu
      const menuItems = document.querySelectorAll('#desktopVerticalMenu .nav--lv1');
      let targetItem = null;

      menuItems.forEach(function(item) {
        const titleElement = item.querySelector('.site-nav--title');
        const link = item.querySelector('.site-nav__link--main');
        
        let itemText = '';
        if (titleElement) {
          itemText = titleElement.textContent.trim();
        } else if (link) {
          itemText = link.textContent.trim();
        }
        
        // Comparație normalizată (elimină spații multiple, newlines, etc)
        const normalizedItemText = itemText.replace(/\s+/g, ' ').trim();
        const normalizedSearchText = settings.itemTitle.replace(/\s+/g, ' ').trim();
        
        if (normalizedItemText === normalizedSearchText) {
          targetItem = item;
        }
      });

      if (!targetItem) {
        console.warn('VerticalMenuHighlight: Nu s-a găsit elementul cu titlul "' + settings.itemTitle + '"');
        return;
      }

      // Aplică stilurile
      this.applyStyles(targetItem, settings);
    },

    /**
     * Aplică stilurile pe elementul găsit
     */
    applyStyles: function(element, settings) {
      const link = element.querySelector('.site-nav__link--main');
      
      if (!link) return;

      // Adaugă clasă pentru identificare
      element.classList.add('custom-highlighted');

      // Aplică culorile de bază
      link.style.backgroundColor = settings.backgroundColor;
      link.style.color = settings.textColor;
      link.style.fontWeight = settings.fontWeight;
      
      if (settings.fontSize) {
        link.style.fontSize = settings.fontSize;
      }

      if (settings.borderColor) {
        link.style.border = '2px solid ' + settings.borderColor;
      }

      // Aplică padding și border radius pentru aspect îmbunătățit
      link.style.padding = '10px 15px';
      link.style.borderRadius = '6px';
      link.style.transition = 'all 0.3s ease';

      // Efect hover
      link.addEventListener('mouseenter', function() {
        this.style.transform = 'translateX(5px)';
        this.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
      });

      link.addEventListener('mouseleave', function() {
        this.style.transform = 'translateX(0)';
        this.style.boxShadow = 'none';
      });

      // Efect de pulsare
      if (settings.pulse) {
        this.addPulseEffect(element);
      }

      // Efect de strălucire
      if (settings.glow) {
        this.addGlowEffect(link, settings.backgroundColor);
      }

      // Adaugă badge
      if (settings.badge) {
        this.addBadge(element, settings.badge, settings.badgeColor);
      }

      // Adaugă icon
      if (settings.icon) {
        this.addIcon(link, settings.icon, settings.textColor);
      }
    },

    /**
     * Adaugă efect de pulsare
     */
    addPulseEffect: function(element) {
      element.classList.add('pulse-effect');
      
      // Adaugă stilurile pentru animație dacă nu există
      if (!document.getElementById('pulse-animation-style')) {
        const style = document.createElement('style');
        style.id = 'pulse-animation-style';
        style.textContent = `
          @keyframes pulseAnimation {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          .pulse-effect {
            animation: pulseAnimation 2s ease-in-out infinite;
          }
        `;
        document.head.appendChild(style);
      }
    },

    /**
     * Adaugă efect de strălucire
     */
    addGlowEffect: function(element, color) {
      const rgbColor = this.hexToRgb(color);
      if (rgbColor) {
        element.style.boxShadow = `0 0 15px rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.6)`;
      }
    },

    /**
     * Adaugă badge pe element
     */
    addBadge: function(element, text, color) {
      // Verifică dacă nu există deja un badge
      if (element.querySelector('.custom-highlight-badge')) {
        return;
      }

      const badge = document.createElement('span');
      badge.className = 'custom-highlight-badge';
      badge.textContent = text;
      badge.style.cssText = `
        position: absolute;
        top: 5px;
        right: 10px;
        background: ${color};
        color: white;
        font-size: 10px;
        font-weight: bold;
        padding: 2px 6px;
        border-radius: 3px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        z-index: 10;
      `;

      element.style.position = 'relative';
      element.appendChild(badge);
    },

    /**
     * Adaugă icon în fața textului
     */
    addIcon: function(link, iconClass, color) {
      const icon = document.createElement('i');
      icon.className = 'fa ' + iconClass;
      icon.style.cssText = `
        margin-right: 8px;
        color: ${color};
        font-size: 14px;
      `;

      const titleSpan = link.querySelector('.site-nav--title');
      if (titleSpan) {
        titleSpan.insertBefore(icon, titleSpan.firstChild);
      } else {
        link.insertBefore(icon, link.firstChild);
      }
    },

    /**
     * Convertește HEX la RGB
     */
    hexToRgb: function(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },

    /**
     * Aplică highlight pe multiple elemente dintr-o dată
     */
    highlightMultipleItems: function(itemsArray) {
      itemsArray.forEach(function(itemConfig) {
        this.highlightMenuItem(itemConfig);
      }.bind(this));
    },

    /**
     * Elimină highlight de pe un element
     */
    removeHighlight: function(itemTitle) {
      const menuItems = document.querySelectorAll('#desktopVerticalMenu .nav--lv1');
      
      menuItems.forEach(function(item) {
        const titleElement = item.querySelector('.site-nav--title');
        if (titleElement && titleElement.textContent.trim() === itemTitle) {
          item.classList.remove('custom-highlighted', 'pulse-effect');
          const link = item.querySelector('.site-nav__link--main');
          if (link) {
            link.style.cssText = '';
          }
          const badge = item.querySelector('.custom-highlight-badge');
          if (badge) {
            badge.remove();
          }
        }
      });
    },

    /**
     * Elimină toate highlight-urile custom
     */
    removeAllHighlights: function() {
      const highlightedItems = document.querySelectorAll('#desktopVerticalMenu .custom-highlighted');
      highlightedItems.forEach(function(item) {
        item.classList.remove('custom-highlighted', 'pulse-effect');
        const link = item.querySelector('.site-nav__link--main');
        if (link) {
          link.style.cssText = '';
        }
        const badge = item.querySelector('.custom-highlight-badge');
        if (badge) {
          badge.remove();
        }
      });
    }
  };

  // Expune obiectul global
  window.VerticalMenuHighlight = VerticalMenuHighlight;

  // Exemplu de utilizare automată la încărcarea paginii
  // Decomentează și configurează după necesități
  /*
  document.addEventListener('DOMContentLoaded', function() {
    
    // Exemplu 1: Highlight simplu cu culoare roșie
    VerticalMenuHighlight.highlightMenuItem({
      itemTitle: 'Laptopuri',
      backgroundColor: '#e74c3c',
      textColor: '#ffffff'
    });

    // Exemplu 2: Highlight cu efect de pulsare și badge
    VerticalMenuHighlight.highlightMenuItem({
      itemTitle: 'Telefoane',
      backgroundColor: '#3498db',
      textColor: '#ffffff',
      pulse: true,
      badge: 'HOT',
      badgeColor: '#e67e22'
    });

    // Exemplu 3: Highlight cu glow și icon
    VerticalMenuHighlight.highlightMenuItem({
      itemTitle: 'Gaming',
      backgroundColor: '#9b59b6',
      textColor: '#ffffff',
      glow: true,
      icon: 'fa-fire',
      badge: 'NEW'
    });

    // Exemplu 4: Multiple items dintr-o dată
    VerticalMenuHighlight.highlightMultipleItems([
      {
        itemTitle: 'Accesorii',
        backgroundColor: '#2ecc71',
        textColor: '#ffffff',
        badge: 'SALE'
      },
      {
        itemTitle: 'TV & Audio',
        backgroundColor: '#f39c12',
        textColor: '#ffffff',
        pulse: true
      }
    ]);
  });
  */

})();

// ============================================================================
// CONFIGURARE RAPIDĂ - Editează aici pentru a activa highlight-urile
// ============================================================================

// Așteaptă ca DOM-ul să fie complet încărcat
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHighlights);
} else {
  initHighlights();
}

function initHighlights() {
  // Așteaptă puțin pentru a fi sigur că meniul este randerat
  setTimeout(function() {
    
    // DEBUG: Afișează toate categoriile din meniu
    // console.log('=== VERTICAL MENU DEBUG ===');
    // const menuItems = document.querySelectorAll('#desktopVerticalMenu .nav--lv1');
    // menuItems.forEach(function(item, index) {
    //   const titleElement = item.querySelector('.site-nav--title');
    //   if (titleElement) {
    //     console.log(index + ': "' + titleElement.textContent.trim() + '"');
    //   } else {
    //     const link = item.querySelector('.site-nav__link--main');
    //     if (link) {
    //       console.log(index + ': "' + link.textContent.trim() + '"');
    //     }
    //   }
    // });
    // console.log('=========================');
    
    // Încearcă mai multe variante ale numelui
    const possibleNames = [
      'Articole Iarna',
      'Articole iarna', 
      'articole iarna',
      'ARTICOLE IARNA'
    ];
    
    let highlighted = false;
    possibleNames.forEach(function(name) {
      if (!highlighted) {
        try {
          window.VerticalMenuHighlight.highlightMenuItem({
            itemTitle: name,
            backgroundColor: '#3498db',
            textColor: '#ffffff',
            pulse: true,
            glow: true,
            badge: 'HOT',
            badgeColor: '#e74c3c',
            icon: 'fa-snowflake-o'
          });
          console.log('✓ Highlight aplicat pentru: "' + name + '"');
          highlighted = true;
        } catch(e) {
          console.log('✗ Nu s-a putut aplica pentru: "' + name + '"');
        }
      }
    });

  }, 1000); // Așteaptă 1 secundă după încărcarea paginii
}
